// COMPONENTS
import * as ComponentLibrary from "@picnicmedia/masanatemples123";
import { AdformReportModalCheckboxProps } from "../types";

/**
 * Component for checkbox group used inside modal
 **/
export function AdformReportModalCheckboxGroup({ supportedMetrics, adformReportingModalInputs, selectOneReportingMetric, selectAllReportingMetrics }: AdformReportModalCheckboxProps) {
  return (
    <ComponentLibrary.PCCheckBoxGroup
      checkBoxValues={supportedMetrics}
      checkedValues={adformReportingModalInputs.selectedMetrics}
      handleChange={selectOneReportingMetric}
      selectAllCheckbox={{
        handleSelectAll: selectAllReportingMetrics,
        allSelected: adformReportingModalInputs.selectedMetrics.length === supportedMetrics.length,
        anySelected:
          adformReportingModalInputs.selectedMetrics.filter((value) => {
            return !adformReportingModalInputs.disabledMetrics.includes(value);
          }).length >= 1,
      }}
      containerHeight={"200px"}
      containerWidth={"450px"}
      disabledValues={adformReportingModalInputs.disabledMetrics}></ComponentLibrary.PCCheckBoxGroup>
  );
}
